



















































































































































import Vue from 'vue';
import api from '@/common/api';
import { mapGetters } from 'vuex';
import PaymentCustomFields from '@/merchant/views/components/customer-payment/PaymentCustomFields.vue';
import { InvoiceCustomer } from './invoices.types';

export default Vue.extend({
  props: {
    customFields: {
      type: Array,
    },
    invoiceCustomer: {
      type: Object as () => InvoiceCustomer,
      required: true,
    },
    showCustomFields: {
      type: Boolean,
      required: false,
      default: false,
    },
    countries: {
      required: true,
    },
    states: {
      required: true,
    },
  },
  data() {
    return {
      customersLoaded: false as boolean,
      customers: [] as any,
      vaultCustomer: {} as any,
    };
  },
  computed: {
    ...mapGetters(['isCustomerVaultEnabled']),
  },
  mounted() {
    if (!this.isCustomerVaultEnabled || this.isCustomerVaultEnabled === undefined) {
      this.$store.dispatch('loadFeatures').then(() => {
        if (this.isCustomerVaultEnabled) {
          this.loadCustomerVault();
        }
      });
    } else if (this.isCustomerVaultEnabled) {
      this.loadCustomerVault();
    }
  },
  methods: {
    loadCustomerVault() {
      api
        .get('customers')
        .then((response) => {
          this.customers = [];
          let customerDataLength = 0;
          if (Object.keys(response.data.data).length) {
            Object.keys(response.data.data).forEach((key: any) => {
              customerDataLength = Number(key) + 1;
              const cust = response.data.data[key];
              if (typeof cust.billingAddress.firstName !== 'undefined' && typeof cust.billingAddress.lastName !== 'undefined') {
                this.customers.push({ text: `${cust.billingAddress.firstName} ${cust.billingAddress.lastName}`, value: cust.billingAddress });
              }
            });

            if (Object.keys(response.data.data).length === customerDataLength) {
              this.customersLoaded = true;
            }
          }
        })
        .catch(() => {
          this.$toasted.error('Failed to load Customers.');
        });
    },
    changeCountry() {
      this.invoiceCustomer.state = '';
    },
    changeCustomer() {
      this.invoiceCustomer.company = this.vaultCustomer.company;
      this.invoiceCustomer.firstName = this.vaultCustomer.firstName;
      this.invoiceCustomer.lastName = this.vaultCustomer.lastName;
      this.invoiceCustomer.email = this.vaultCustomer.email;
      this.invoiceCustomer.address1 = this.vaultCustomer.address1;
      this.invoiceCustomer.address2 = this.vaultCustomer.address2;
      this.invoiceCustomer.city = this.vaultCustomer.city;
      this.invoiceCustomer.state = this.vaultCustomer.state;
      this.invoiceCustomer.zip = this.vaultCustomer.zip;
      this.invoiceCustomer.country = this.vaultCustomer.country;
    },
  },
  components: {
    PaymentCustomFields,
  },
});

